// extracted by mini-css-extract-plugin
export default {"body":"System_body__aCR-F","stars__container":"System_stars__container__2RVzk","rightInfo":"System_rightInfo__gJwXN","scrollto__planet":"System_scrollto__planet__YLXyS"};